import store from '../store'

class notifService {
  notif(gr, ti, ty) {
    store.dispatch('menu/setNotif', {
      group: gr,
      title: ti,
      type: ty
    })
  }
}

export default new notifService()
